import React from "react";
import { PiMetronome } from "react-icons/pi";
import { Tooltip } from "./Tooltip";

interface BPMSliderProps {
  bpm: number;
  onBPMChange: (newBPM: number) => void;
  controlsLocked?: boolean;
}

export const BPMSlider: React.FC<BPMSliderProps> = ({
  bpm,
  onBPMChange,
  controlsLocked,
}) => {
  const handleSliderChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (controlsLocked) return;
    const newBPM = parseInt(e.target.value, 10);
    onBPMChange(newBPM);
  };

  return (
    <div
      className={`bpm-slider-container ${!controlsLocked ? "visible" : ""}`}
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "15px",
        width: "100%",
        maxWidth: "400px",
      }}
    >
      <div
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          gap: "20px",
        }}
      >
        {/* Metronome Icon */}
        <Tooltip text="BPM" position="top">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "24px",
              height: "24px",
              color: "var(--icon-color)",
              flexShrink: 0,
            }}
          >
            {PiMetronome({
              size: 20,
              style: { filter: "drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3))" },
            })}
          </div>
        </Tooltip>

        <input
          type="range"
          min="30"
          max="300"
          value={bpm}
          onChange={handleSliderChange}
          style={{
            flex: 1,
            height: "4px",
            borderRadius: "3px",
            background: `linear-gradient(to right, var(--slider-track) 0%, var(--slider-track) ${
              ((bpm - 20) / 280) * 100
            }%, var(--slider-thumb) ${
              ((bpm - 20) / 280) * 100
            }%, var(--slider-thumb) 100%)`,
            outline: "none",
            cursor: "pointer",
            WebkitAppearance: "none",
            appearance: "none",
          }}
          onMouseDown={(e) => {
            const slider = e.currentTarget;
            slider.style.cursor = "grabbing";
          }}
          onMouseUp={(e) => {
            const slider = e.currentTarget;
            slider.style.cursor = "pointer";
          }}
        />
      </div>
      <style>
        {`
          input[type="range"]::-webkit-slider-thumb {
            -webkit-appearance: none;
            appearance: none;
            width: 18px;
            height: 18px;
            border-radius: 50%;
            background: var(--slider-thumb-hover) !important;
            cursor: pointer;
            border: none;
            box-shadow: 0 0 15px var(--slider-thumb), 0 4px 16px rgba(0, 0, 0, 0.2);
            transition: all 0.3s ease;
          }
          
          input[type="range"]::-moz-range-thumb {
            width: 18px;
            height: 18px;
            border-radius: 50%;
            background: var(--slider-thumb-hover) !important;
            cursor: pointer;
            border: none;
            box-shadow: 0 0 15px var(--slider-thumb), 0 4px 16px rgba(0, 0, 0, 0.2);
            transition: all 0.3s ease;
            -moz-appearance: none;
          }
        `}
      </style>
    </div>
  );
};
